module.exports = __webpack_public_path__ + "img/playMind.4e64a4bb.svg";